var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sj-blank"},[_c('i',{staticClass:"icon_com comicon_blankdata"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.localText))])])}
var staticRenderFns = []

export { render, staticRenderFns }